import { Eye, EyeSlash } from '@phosphor-icons/react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { FormField, type FormFieldProps } from './form-field'

interface PasswordFieldProps extends Omit<FormFieldProps, 'type' | 'trailing'> {
  /**
   * The Flutter login password field has no reveal control; registration and
   * reset keep it. Defaults to showing the control.
   */
  hideToggle?: boolean
}

/** Password input with an accessible show/hide control (UI_PARITY §3.3). */
export function PasswordField({
  hideToggle = false,
  ...props
}: PasswordFieldProps) {
  const { t } = useTranslation()
  const [visible, setVisible] = useState(false)

  return (
    <FormField
      {...props}
      type={visible ? 'text' : 'password'}
      autoComplete={props.autoComplete ?? 'current-password'}
      trailing={
        hideToggle ? undefined : (
          <button
            type="button"
            className="btn-ghost size-11 rounded-full p-0"
            aria-label={
              visible
                ? t('auth.common.hidePassword')
                : t('auth.common.showPassword')
            }
            aria-pressed={visible}
            onClick={() => setVisible((current) => !current)}
          >
            {visible ? (
              <EyeSlash size={22} weight="bold" aria-hidden="true" />
            ) : (
              <Eye size={22} weight="bold" aria-hidden="true" />
            )}
          </button>
        )
      }
    />
  )
}
